import React from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {Button, Link, Stack} from '@customink/pigment-react';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {removeAll} from '~/actions/NamesAndNumbersActions';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function NamesAndNumbersAndMultiColorError({dismiss, ...props}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const goToProductCatalog = () => {
    navigate('/productCatalog');
    dismiss();
  };

  const removeNamesAndNumbers = () => {
    dispatch(removeAll());
    dismiss();
  };

  return (
    <Notification
      {...props}
      title="This product doesn't support names and numbers and multiple ink colors.">
      <p className="ndx-cta1">
        {
          "If you continue we'll remove names and numbers but you'll have to update"
        }
        your design before checking out.
      </p>
      <Stack className="notification-stack">
        <Button
          size="large"
          variant="secondary"
          className="notification-cta"
          onClick={removeNamesAndNumbers}>
          Continue
        </Button>
        <p className="ndx-cta1">
          or{' '}
          <Link button onClick={goToProductCatalog}>
            go back
          </Link>
          .
        </p>
      </Stack>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func
};

NamesAndNumbersAndMultiColorError.propTypes = propTypes;

NamesAndNumbersAndMultiColorError.displayName =
  'NamesAndNumbersAndMultiColorError';
